import { render } from "./DashbordSample.vue?vue&type=template&id=067a5bba&scoped=true"
import script from "./DashbordSample.vue?vue&type=script&lang=js"
export * from "./DashbordSample.vue?vue&type=script&lang=js"

import "./DashbordSample.vue?vue&type=style&index=0&id=067a5bba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067a5bba"]])

export default __exports__